import {
  ChartColumnIcon,
  CloudCheckIcon,
  HoverCard,
} from '@buffer-mono/popcorn'

import {
  SyncPopoverContent,
  SyncSection,
  SyncSectionText,
} from '~publish/components/SyncPopover'
import syncPopoverStyles from '~publish/components/SyncPopover/syncPopover.module.css'

import { getTimeAgo } from '../../utils'

import styles from './SyncIcon.module.css'

import type { JSX } from 'react'

/** Both metric collections run on the same daily cycle. */
const METRICS_CADENCE = 'Updated every 24 h'

/**
 * Sync status for an Insights header. Post and channel metrics are collected
 * separately, so each reports its own last-collected time.
 */
export const SyncIcon = ({
  postsLastUpdatedAt,
  channelLastUpdatedAt,
}: {
  postsLastUpdatedAt?: string | null
  channelLastUpdatedAt?: string | null
}): JSX.Element => (
  <HoverCard openDelay="fast" closeDelay="fast">
    <HoverCard.Trigger>
      <button
        type="button"
        className={styles.hoverCardTrigger}
        aria-label="Sync status"
      >
        <div className={styles.syncIconContainer}>
          <CloudCheckIcon className={styles.syncIcon} />
        </div>
      </button>
    </HoverCard.Trigger>
    <HoverCard.Content
      className={syncPopoverStyles.content}
      align="center"
      side="bottom"
    >
      <SyncPopoverContent title="How Insights stay updated">
        <SyncSection
          icon={<ChartColumnIcon size="small" />}
          label="Post metrics"
          trailing={
            <SyncSectionText>{getTimeAgo(postsLastUpdatedAt)}</SyncSectionText>
          }
        >
          <SyncSectionText>{METRICS_CADENCE}</SyncSectionText>
        </SyncSection>
        <SyncSection
          icon={<ChartColumnIcon size="small" />}
          label="Channel metrics"
          trailing={
            <SyncSectionText>
              {getTimeAgo(channelLastUpdatedAt)}
            </SyncSectionText>
          }
        >
          <SyncSectionText>{METRICS_CADENCE}</SyncSectionText>
        </SyncSection>
      </SyncPopoverContent>
    </HoverCard.Content>
  </HoverCard>
)
